import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';
export const routes: Array<RouteRecordRaw> = [];
interface Moudle {
  default: RouteRecordRaw
}

routes.push(
  {
    name: 'index',
    path: "/",
    component: () => import(`@/pages/views/index.vue`),
    meta: {
      title: '加载中...'
    }
  },
  {
    name: 'material',
    path: "/material",
    component: () => import(`@/pages/views/material.vue`),
    meta: {
      title: '素材调试'
    }
  },
  {
    name: 'fission',
    path: "/fission",
    component: () => import(`@/pages/views/fission.vue`),
    meta: {
      title: '极速裂变'
    }
  },
  {
    name: 'combination',
    path: "/combination",
    component: () => import(`@/pages/views/combination.vue`),
    meta: {
      title: '组合优化'
    }
  },
  {
    name: '401',
    path: "/401",
    component: () => import(`@/pages/error/401.vue`),
    meta: {
      title: '页面失效'
    }
  },
  {
    name: 'NotFound',
    path: '/:catchAll(.*)',
    component: () => import(`@/pages/error/404.vue`),
    meta: {
      title: '未找到此页面'
    }
  },
)

// 将modules下的全部路由配置文件加载到routes中
// const moduleRouterList = import.meta.glob('pages/routers/*.ts', { eager: true });
// for (const path in moduleRouterList) {
//   const routerInstance = (moduleRouterList[path] as Moudle).default;
//   // 自动关联routers与views 下的同名文件
//   routerInstance.component = () => import(`@/pages/views/${routerInstance.name as string}.vue`);
//   routes.push(routerInstance);
// }

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

router.beforeResolve(async to => {
  if (to.meta.title) {
    window.document.title = to.meta.title as string;
  }
});
